export enum AdminTicketsActionTypes {
    API_RESPONSE_SUCCESS = "@@admin_tickets/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@admin_tickets/API_RESPONSE_ERROR",
    GET_ADMIN_TICKETS = "@@admin_tickets/GET_ADMIN_TICKETS",
    GET_ADMIN_TICKET_STATUS ="@@admin_tickets/GET_ADMIN_TICKET_STATUS",
    UPDATE_ADMIN_TICKET_STATUS ="@@admin_tickets/UPDATE_ADMIN_TICKET_STATUS",
    GET_ADMIN_TICKETS_COUNT = "@@admin_tickets/GET_ADMIN_TICKETS_COUNT",
  }
  